import { atom } from 'recoil';

export const adventureState = atom({
	key: 'adventureState',
	default: null,
});

export const adventureBackgroundImageState = atom({
	key: 'adventureBackgroundImageState',
	default: null,
});

export const adventureBackgroundColorState = atom({
	key: 'adventureBackgroundColorState',
	default: null,
});
